// Development environment configuration (Dev)
export const environment = {
  production: false,
  apiUrl: 'https://servitzbot-api-dev.fritz.co.il/api'
};

